var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.375L22.6225 21.4969C23.2474 20.6382 23.5835 19.6033 23.5825 18.5413C23.5825 15.7616 21.3209 13.5 18.5413 13.5C15.7616 13.5 13.5 15.7616 13.5 18.5413C13.5 21.3209 15.7616 23.5825 18.5413 23.5825C19.6033 23.5835 20.6382 23.2474 21.4969 22.6225L25.375 26.5L26.5 25.375ZM18.5413 21.9903C17.859 21.9904 17.1921 21.7881 16.6248 21.4091C16.0575 21.0301 15.6153 20.4914 15.3542 19.8611C15.0931 19.2308 15.0247 18.5372 15.1578 17.8681C15.2909 17.1989 15.6194 16.5843 16.1019 16.1019C16.5843 15.6194 17.1989 15.2909 17.8681 15.1578C18.5372 15.0247 19.2308 15.0931 19.8611 15.3542C20.4914 15.6153 21.0301 16.0575 21.4091 16.6248C21.7881 17.1921 21.9904 17.859 21.9903 18.5413C21.9892 19.4557 21.6255 20.3323 20.9789 20.9789C20.3323 21.6255 19.4557 21.9892 18.5413 21.9903V21.9903Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.b824dcd2bc56db48a3d0c13e4891b422.svg";
export { ForwardRef as ReactComponent };